import { render, staticRenderFns } from "./CampainBuilderPage.vue?vue&type=template&id=0f00400b&"
import script from "./CampainBuilderPage.vue?vue&type=script&lang=js&"
export * from "./CampainBuilderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports